/**
 * @param {vueInstance} context - This
 * @returns {LastActivity}
 */
export default function (context) {
  const { id } = context.item

  return {
    key: 'activity_by_leads',
    resource: 'activity_by_leads',
    type: 'LastActivity',
    title: {
      id: 'recentActivity',
      label: `${context.$t('recent')} ${context.$tc('lead', 2).toLowerCase()}`,
      icon: '',
      style: true,
    },
    footer: {
      id: 'activity_by_leads',
      label: `${context.$t('showAll')} ${context.$tc('lead', 2).toLowerCase()}`,
      icon: ['fal', 'arrow-to-right'],
      component: 'router-link',
      props: {
        style: { textAlign: 'center', width: '100%' },
        theme: 'primary',
        to: {
          name: `${context.type}-leads`,
          params: { id },
          query: context.$route.query,
        },
      },
    },
    data: ({ data = {} }) => data.data,
  }
}
